class DelectoryCache {
  constructor() {
    this._cache = {};
  }

  put(key, value, ttl) {
    this._cache[key] = {
      expires: Date.now() + ttl,
      value: value
    };
  }

  get(key) {
    let data = this._cache[key];
    if(data && data.expires >= Date.now()) {
      return data.value;
    }
    delete this._cache[key];
    return null;
  }
}

export default DelectoryCache;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/DelectoryCache.js